import { httpRequest } from "@services/http";

/** One ad token note the server found in an ad's copy. Known tokens are omitted. */
export type AdTokenNoteFinding = {
  field: string;
  token: string;
  kind: "unknown" | "alias" | "instruction";
};

export type AdTokenNotes = {
  /** `unavailable` = the server has no active ad tokens to check against. */
  status: "ready" | "unavailable";
  /** Keyed by Ad id. An Ad the caller cannot see is absent. */
  ads: Record<string, { ad_copy: AdTokenNoteFinding[]; creative: unknown | null }>;
};

/*
    The ad token notes for these ads' saved copy (MPN-2192), computed by the server on read.

    Its own request rather than a field on the ad payload, for the same reason as provenance:
    that payload is also what a client reviewer is served. One request covers many ads.
*/
export class CommandGetAdTokenNotes {
  async run(adIds: number[]): Promise<AdTokenNotes> {
    if (adIds.length === 0) return { status: "ready", ads: {} };
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/ad-token-notes/?ids=${adIds.join(",")}`;
    return await httpRequest<AdTokenNotes>(url);
  }
}
